__turbopack_context__.v({
  "buttonWrapperAPIKeys": "ydANFW_buttonWrapperAPIKeys",
  "close": "ydANFW_close",
  "dark": "ydANFW_dark",
  "exchangeClose": "ydANFW_exchangeClose",
  "getAPIKeys": "ydANFW_getAPIKeys",
  "header": "ydANFW_header",
  "homeLink": "ydANFW_homeLink",
  "logo": "ydANFW_logo",
  "logoImage": "ydANFW_logoImage",
  "logoText": "ydANFW_logoText",
  "mobileHeader": "ydANFW_mobileHeader",
  "nav": "ydANFW_nav",
  "plaidDotCom": "ydANFW_plaidDotCom",
  "search": "ydANFW_search",
  "searchAndVersion": "ydANFW_searchAndVersion",
  "shrinkContainer": "ydANFW_shrinkContainer",
  "sidebar": "ydANFW_sidebar",
});
